import React from 'react';
import Reflux from 'reflux';
import {Button, Icon, message, Popconfirm} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice, objectSerial, config} from 'Utils';
import moment from "moment";
import {getOrderList, getGouXiaoUnitList, deleterRecord, pushEsign, viewEsign} from "../../service/transportSplit";

class transportSplitList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.state = {
            opts: ['出库单二次配送'],
            showHideBtnIndex: '',
            key: 0,
            prolineVisible: false,
            selectedRowKeys: [],
            gouxiaoUnitList: [],
            rows: [],
            total: 1,
            searchObj: {
                status: '',
                salesChannelCode: this.channelData.split('|')[1] || '',
                salesUnitId: '',
                startCreatedDate: '',
                endCreatedDate: '',
                orderNumber: '',
                deliveryId: '',
                signMethod: '',
                eSignPost: '',
                s: 10,
                p: 1
            },
            categoryData: [],
            visible: false,
            value: '',
            loading: true,
            pushLoading: false,
            eSingStatusList: [
                {value: 'DRAFT', text: '草稿'},
                {value: 'FILLING', text: '拟定中'},
                {value: 'SIGNING', text: '签署中'},
                {value: 'COMPLETE', text: '已完成'},
                {value: 'REJECTED', text: '已拒签'},
                {value: 'RECALLED', text: '已撤回'},
                {value: 'EXPIRED', text: '已过期'},
                {value: 'TERMINATING', text: '作废中'},
                {value: 'TERMINATED', text: '已作废'},
                {value: 'DELETE', text: '已删除'},
                {value: 'FINISHED', text: '强制完成'},
                {value: 'ERROR', text: '异常'},
            ]
        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.exportChange = this.exportChange.bind(this);
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
    };

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    /*筛选*/
    setFilterParam(name, value) {
        if (name == 'shipTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    startCreatedDate: value.from,
                    endCreatedDate: value.end
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}});
        }

    };

    /*筛选重置*/
    advanceReset() {
        this.setState({
            searchObj: {
                status: '',
                salesUnitId: '',
                deliveryId: '',
                salesChannelCode: this.channelData.split('|')[1] || '',
                startCreatedDate: '',
                endCreatedDate: '',
                signMethod: '',
                eSignPost: '',
                s: 10,
                p: 1
            }, loading: true
        }, () => {
            this.initData();
        });
    };

    /* 筛选确认 */
    advanceSubmit(form) {
        let self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }, loading: true
        }, function () {
            self.initData();
        });
    };

    /*翻页*/
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.initData();
        });
    }

    /*获取列表数据*/
    initData() {
        let self = this;
        let obj = self.state.searchObj;
        getOrderList(obj).then(result => {
            if (result.status) {
                this.setState({
                    rows: result.data || [],
                    total: result.total,
                    loading: false
                })
            } else {
                message.error(result.message);
                this.setState({loading: false});
            }
        })

    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
    }

    componentDidMount() {
        let self = this;
        let channelCode = window.sessionStorage.getItem('cur_channelId');
        this.initData();
        getGouXiaoUnitList({channelCode: channelCode, s: 999}).then(res => { //购货单位
            if (res.status) {
                const data = res.data || [];
                let arr = [
                    {
                        text: '全部',
                        value: '0'
                    }
                ];
                for (let i = 0; i < data.length; i++) {
                    let x = data[i];
                    arr.push({
                        text: x.name,
                        value: x.id
                    })
                }
                self.setState({gouxiaoUnitList: arr})
            }
        });
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    showHideBtn(index) {
        this.setState({
            showHideBtnIndex: index
        });
    }

    hideBtn() {
        this.setState({
            showHideBtnIndex: ''
        });
    }

    editRecord(record) {
        this.goView('transportSplit/edit/' + record.id);
    }

    pushEsign(record) {
        this.setState({pushLoading: true});
        pushEsign(record.id).then(res => {
            if (res.code === 200) {
                openNotice('success', '发起成功');
                this.initData();
                this.setState({pushLoading: false});
            }
        });
    }

    viewEsign(record) {
        viewEsign(record.id).then(res => {
            if (res.code === 200 && res.status) {
                window.open(res.data);
            }
        });
    }

    deleteItem(record) {
        deleterRecord({id: record.id}).then(res => {
            if (res.code === 200) {
                openNotice('success', '删除成功');
                this.initData();
            }
        });
    }

    handleOk = () => {
        this.setState({visible: false});
    }

    handleCancel = () => {
        this.setState({visible: false});
    }

    onChange = (e) => {
        this.setState({
            value: e.target.value
        });
    }

    handleChange() {

    }

    exportChange() {
        let _searchObj = {...this.state.searchObj};
        delete _searchObj.s;
        delete _searchObj.p;
        let url = `${config.server}/api/v1/dms/tgTransTransportSplitHeader/exportOrder?${objectSerial(_searchObj)}`;
        window.open(url);
    };

    render() {
        const {
            opts,
            key,
            rows,
            total,
            searchObj,
            gouxiaoUnitList,
            loading,
            eSingStatusList
        } = this.state;
        const advanceProps = {
            fileds: [
                {
                    name: 'shipTime',//startCreatedDate, endCreatedDate
                    label: '登记日期',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.startCreatedDate,
                        end: searchObj.endCreatedDate
                    }
                },
                {
                    name: 'status',
                    label: '状态',
                    text: '选择状态',
                    options: [
                        {value: '', text: '全部'},
                        {value: '0', text: '保存'},
                        {value: '1', text: '已提交'},
                        {value: '2', text: '已完成'}
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.status
                },
                {
                    name: 'signMethod',
                    label: '是否发起电签',
                    text: '选择状态',
                    options: [
                        {value: '', text: '全部'},
                        {value: '0', text: '否'},
                        {value: '1', text: '是'}
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.signMethod
                },
                {
                    name: 'eSignPost',
                    label: '是否已发起',
                    text: '选择状态',
                    options: [
                        {value: '', text: '全部'},
                        {value: '0', text: '否'},
                        {value: '1', text: '是'}
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.eSignPost
                },
                {
                    name: 'salesUnitId',
                    label: '购货单位',
                    text: '输入购货单位',
                    type: 'select',
                    multiple: false,
                    showSearch: true,
                    options: gouxiaoUnitList,
                    defaultValue: searchObj.salesUnitId
                },
                {
                    name: 'orderNumber',
                    label: '单号',
                    text: '输入单号',
                    type: 'default',
                    defaultValue: searchObj.orderNumber
                },
                {
                    name: 'deliveryId',
                    label: '出库单号',
                    text: '输入出库单号',
                    type: 'default',
                    defaultValue: searchObj.deliveryId
                }, {
                    name: 'remark',
                    label: '备注',
                    text: '输入备注',
                    type: 'default',
                    defaultValue: searchObj.remark
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '单号',
                    dataIndex: 'orderNumber',
                    render: (text, record, index) => {
                        return <a href={`#/transportSplit/edit/${record.id}`}>{text}</a>
                    }
                },
                {
                    title: '日期',
                    dataIndex: 'createdDate',
                    render: (text, record, index) => {
                        return <div>{moment(parseInt(text)).format('YYYY-MM-DD')}</div>
                    }
                },
                {
                    title: '状态',
                    dataIndex: 'status',
                    render: (text) => {
                        if (text === 0) {
                            return '保存'
                        }
                        if (text === 1) {
                            return '已提交'
                        }
                        if (text === 2) {
                            return '已完成'
                        }
                    }
                },
                {
                    title: '购货单位',
                    dataIndex: 'purchaseName'
                },
                {
                    title: '是否发起电签',
                    dataIndex: 'signMethod',
                    render: (text) => {
                        if (text === 1) {
                            return '是'
                        }
                        if (text === 0) {
                            return '否'
                        }
                    }
                },
                {
                    title: '电子签状态',
                    dataIndex: 'eSignStatus',
                    render: function (text, record, index) {
                        if (text != null) {
                            let status = eSingStatusList.filter((item) => {
                                return item.value === text
                            });
                            return status ? status[0].text : '-';
                        }
                    }
                },
                {
                    title: '签署人',
                    dataIndex: 'eSignLinkman',
                },
                {
                    title: '备注',
                    dataIndex: 'remark'
                },
                {
                    title: '附件',
                    dataIndex: 'filePath',
                    render: (text, record, index) => {
                        if (record.filePath) {
                            return (
                                <a href={config.server + record.filePath.replace("getFile", "getFileDown")}>{record.fileName}</a>)
                        }
                    }
                },
                {
                    title: '操作',
                    render: (text, record, index) =>
                        <div>
                            {record.status === 0 ?
                                <div className="event">
                                    <Button style={{display: 'inline-block', marginRight: '10px'}} size={'small'}
                                            type="ghost"
                                            onClick={() => {
                                                this.editRecord(record)
                                            }}>编辑</Button>
                                    <Popconfirm placement="left" title='您确定要删除吗！' onConfirm={() => {
                                        this.deleteItem(record)
                                    }}>
                                        <Button size={'small'} type="danger">删除</Button>
                                    </Popconfirm>
                                </div> :
                                record.eSignNo == null && record.signMethod == 1 ? <div className="event">
                                    <Popconfirm placement="left" title='发起电签需要等待一会，请不要多次点击'
                                                onConfirm={() => {
                                                    this.pushEsign(record)
                                                }}>
                                        <Button size={'small'} type="danger"
                                                loading={this.state.pushLoading}>发起电签</Button>
                                    </Popconfirm>
                                </div> : record.eSignNo != null ? <div className="event"><Button
                                    style={{display: 'inline-block', marginRight: '10px'}}
                                    size={'small'}
                                    type="primary"
                                    onClick={() => {
                                        this.viewEsign(record)
                                    }}>查看电签</Button></div> : <span>暂无操作</span>}
                        </div>
                }
            ],
            rows
        };
        return <div>
            <DmsTab options={opts} defaultKey={key}></DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps} />
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    <Button style={{position: 'absolute', bottom: 8, left: 0}}
                            onClick={this.goView.bind(this, '/transportSplit/add')}>创建</Button>
                    {/*<Button style={{position: 'absolute', bottom: 8, right: 0}} icon="export"*/}
                    {/*        onClick={this.exportChange}>导出</Button>*/}
                </div>
                <TableView {...tableViewProps} />
            </div>

        </div>
    }
}

export default withRouter(transportSplitList);



// WEBPACK FOOTER //
// ./src/routes/transportSplit/list.js